var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 24,
    viewBox: "0 0 222 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.773 8.81709C221.186 8.45035 221.223 7.81829 220.856 7.40535L214.88 0.676095C214.513 0.263154 213.881 0.2257 213.468 0.592441C213.055 0.959182 213.018 1.59124 213.385 2.00418L218.697 7.98574L212.715 13.2981C212.302 13.6648 212.265 14.2969 212.632 14.7098C212.999 15.1228 213.631 15.1602 214.044 14.7935L220.773 8.81709ZM0.838388 24.0085C82.9976 5.46479 131.397 3.81449 220.05 9.06764L220.168 7.07114C131.384 1.8102 82.7881 3.46177 0.398055 22.0576L0.838388 24.0085Z",
    fill: "#006D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.42b6395b81b752aaa934634e0ce47e4d.svg";
export { ForwardRef as ReactComponent };